"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupCheckbox = void 0;
var _VCSIcons = _interopRequireDefault(require("@vectorworks/vcs-icons/VCS Icons.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const setupCheckbox = () => {
  document.querySelector(':root').style.setProperty('--icon-check', `"${_VCSIcons.default["check"]}"`);
};
exports.setupCheckbox = setupCheckbox;
setupCheckbox();